import { createAsyncThunk } from '@reduxjs/toolkit';
import { medicalService, registerService } from 'services';
import { t_medical_institution, UpdateMedicalResponse } from 'types';

export const getFieldMedical = createAsyncThunk<any, { appId: string; dataStoreId: string }>(
  'medicalEdit/getFieldMedical',
  async (params) => {
    const { data } = await registerService.getDataStoreFields(params);
    return data;
  },
);

export const updateMedical = createAsyncThunk<UpdateMedicalResponse, t_medical_institution>(
  'medicalEdit/updateMedical',
  async (params) => {
    const { data } = await medicalService.updateMedical(params);
    return data;
  },
);
